module.exports = __webpack_public_path__ + "static/media/IMG_20150809_184239.586185d6.jpg";